import { Typography, Tabs } from 'antd';
import { useParams } from 'react-router-dom';

const { Title } = Typography;

const RfoDetailPage = () => {
  const { id } = useParams();

  const items = [
    { key: 'intake', label: 'Intake', children: <div>Intake content</div> },
    { key: 'qualification', label: 'Qualification', children: <div>Qualification content</div> },
    { key: 'planning', label: 'Planning', children: <div>Planning content</div> },
    { key: 'compliance', label: 'Compliance', children: <div>Compliance content</div> },
    { key: 'reviews', label: 'Reviews', children: <div>Reviews content</div> },
    { key: 'submission', label: 'Submission', children: <div>Submission content</div> },
    { key: 'documents', label: 'Documents', children: <div>Documents content</div> },
    { key: 'audit', label: 'Audit Trail', children: <div>Audit trail content</div> },
  ];

  return (
    <div>
      <Title level={2}>RFO Details - {id}</Title>
      <Tabs items={items} style={{ marginTop: 24 }} />
    </div>
  );
};

export default RfoDetailPage;
